import {
  BackQuote,
  ImageWithLabel,
  ExternalLink,
  Htags,
  InternalLink,
  Paragraph,
} from "../components"
import React from "react"
import { useIsLangEN } from "../hooks"

const H1 = props => {
  return <Htags {...props}></Htags>
}

const H2 = props => {
  // console.log("H2??????", props)
  return <Htags.h2 {...props}></Htags.h2>
}

const H3 = props => {
  // console.log("H2??????", props)
  return <Htags.h3 {...props}></Htags.h3>
}

const Anchor = props => {
  // console.log("anchor props", props)
  if (props.href.startsWith("http")) {
    return <ExternalLink {...props}></ExternalLink>
  } else return <InternalLink {...props}>{props.children}</InternalLink>
}

const Blockquote = props => {
  return <BackQuote isGreenbox>{props.children.props.children}</BackQuote>
}

const Paragraph4MDX = props => {
  const isLangEN = useIsLangEN()
  return (
    <Paragraph>
      {props.children}
      <br />
      <br />
    </Paragraph>
  )
}

const EM = props => {
  if (props.children === "The Final Escape" || props.children === "King Lear") {
    // special patch
    return <em {...props} style={{ fontWeight: 400 }}></em>
  }
  return <em {...props}></em>
}

const Image = props => {
  console.log("image props", props)
  return <img {...props} style={{ width: "100%" }}></img>
}

const mdxProviderConfig = {
  blockquote: Blockquote,
  h1: H1,
  a: Anchor,
  h2: H2,
  h3: H3,
  p: Paragraph4MDX,
  em: EM,
}
export default mdxProviderConfig
